import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { NbDialogService, NbIconModule } from '@nebular/theme';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CartEventService } from "compob2b-libs";
import { PopupLoginComponent } from "../../../auth/popup-login/login.component";
import { AsyncPipe, NgForOf, NgIf } from "@angular/common";
import { CatalogMobileSelectorService } from "../../catalog/services/catalog-mobile-selector.service";

interface FooterItem {
  icon: string;
  label: string;
  link?: string;
  badge?: Observable<number>;
}

@Component({
  selector: 'app-footer-mobile',
  templateUrl: './footer-mobile.component.html',
  styleUrls: ['./footer-mobile.component.scss'],
  imports: [
    NbIconModule,
    RouterLink,
    AsyncPipe,
    NgForOf,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterMobileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isLogged = false;

  footerItems: FooterItem[] = [];

  private readonly destroy$ = new Subject<void>();
  amount$: Observable<number>;

  constructor(
    public readonly router: Router,
    private readonly dialogService: NbDialogService,
    private readonly cartEventService: CartEventService,
    private readonly catalogMobileSelectorService: CatalogMobileSelectorService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.amount$ = this.cartEventService.getAmount();

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => this.cdr.markForCheck());

    this.amount$.pipe(takeUntil(this.destroy$))
      .subscribe(() => this.cdr.markForCheck());

    this.buildItems();
  }

  ngOnChanges(): void {
    this.buildItems();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isRouteActive(path: string): boolean {
    const current = this.router.url.split(/[?#]/)[0];
    return current === path || (path !== '/' && current.startsWith(path + '/'));
  }

  handleLoginClick(event: Event): void {
    event.preventDefault();
    this.dialogService.open(PopupLoginComponent, { closeOnEsc: true });
  }

  handleCatalogClick(event: Event): void {
    if (this.isRouteActive('/catalog')) {
      event.preventDefault();
      this.catalogMobileSelectorService.nextOpenSelector();
    }
  }

  private buildItems(): void {
    this.footerItems = [
      {
        icon: 'home-outline',
        label: 'Главная',
        link: '/cabinet/dashboard',
      },
      {
        icon: 'grid-outline',
        label: 'Каталог',
        link: '/catalog',
      },
      {
        icon: this.isLogged ? 'car-outline' : 'bulb-outline',
        label: this.isLogged ? 'Заказы' : 'Инфо',
        link: this.isLogged ? '/cabinet/reports/orders' : '/information',
      },
      {
        icon: 'shopping-cart-outline',
        label: 'Корзина',
        link: '/cart',
        badge: this.amount$,
      },
      {
        icon: this.isLogged ? 'person-outline' : 'log-in-outline',
        label: this.isLogged ? 'Профиль' : 'Войти',
        link: this.isLogged ? '/cabinet/private/account' : undefined,
      },
    ];
  }
}
